import React from 'react';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { useUserOffices } from '../../../hooks/useUserOffices';
import LoadingSpinner from '../../common/controls/LoadingSpinner';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import Box from '@mui/material/Box';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useRemoveUserOffice } from '../../../hooks/useRemoveUserOffice';

export default function UserOfficesList({ toggleUserListTrigger, user = null, trigger}) {

    const { t } = useTranslation('common');

    const { userOffices, loading } = useUserOffices(user.id, trigger);

    const { remove } = useRemoveUserOffice();

    const { showSnackbar } = useSnackbar();

    const handleRemove = async (user, office) => {
        try {
            await remove(user.id, office.id);
            toggleUserListTrigger();
            showSnackbar(t('user_offices.messages.remove_success', { office: office.name, name: user.name }), "success");
        } catch (err) {
            showSnackbar(t('user_offices.messages.remove_fail', { office: office.name, name: user.name }), "error");
        }
    };

    if (loading) {
        return (
            <LoadingSpinner />
        );
    }

    return(
        <List>
            {userOffices.offices.map((office) => (
            <ListItem
                key={office.id}
                secondaryAction={
                    <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                        <VerticalHamburgerMenu 
                            options={[
                            {
                                id: 2,
                                name: 'Remove',
                                callback: () => handleRemove(user, office),
                                confirmMessage: t('user_offices.messages.remove_confirm', { name: user.name, office: office.name }),
                            },
                            ]}
                        />
                    </Box>
                }
            >
                <ListItemText 
                    primary={office.name}  
                    secondary={office.company ? office.company.name : ""}
                />
            </ListItem>
            ))}
        </List>
    );
}